module.exports = __webpack_public_path__ + "static/img/banner04.7dff555.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner04.png
// module id = 930
// module chunks = 0